<script setup lang="ts">
  import { Typo, Picture, Icon, PictureFormat, Button } from '@travelata-libs/ui-kit';
  import type { Product } from '@/entities/product';
  import type { SearchCriteria } from '@/entities/searchCriteria';

  interface EmiratesBannerProps {
    product?: Product;
    searchCriteria?: SearchCriteria;
    cardPosition?: number;
  }

  defineProps<EmiratesBannerProps>();

  interface EmiratesBannerEmits {
    (e: 'select'): void;
  }

  const emit = defineEmits<EmiratesBannerEmits>();

  const onClick = (): void => {
    emit('select');
  };
</script>

<template>
  <div class="fr-emirates-banner">
    <ClientOnly>
      <div class="fr-emirates-banner__up">
        <Picture
          class="fr-emirates-banner__travelata"
          path="travelata/logo/logo-white.svg"
          fit="contain"
        />
        <Icon
          class="fr-emirates-banner__icon"
          name="close"
        ></Icon>
        <Picture
          class="fr-emirates-banner__emirates"
          path="travelata/emirates-white.png"
          :high-resolution="true"
          :extensions="[PictureFormat.PNG]"
        />
      </div>
      <div class="fr-emirates-banner__container">
        <Typo
          class="fr-emirates-banner__typo"
          variant="body-l-500"
        >
          Специальное предложение
          <br />
          в ОАЭ из МСК и СПб
        </Typo>
        <Button
          class="fr-emirates-banner__button"
          icon-left="arrow-up-right"
          appearance="tertiary"
          size="s"
          @click="onClick"
        />
      </div>
    </ClientOnly>
  </div>
</template>

<style scoped lang="scss">
  .fr-emirates-banner {
    background: linear-gradient(0deg, #f66 0%, #d71921 100%);
    border-radius: var(--rounding-xl);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 96px;
    padding: var(--spacing-m);

    &__button {
      border-color: var(--color-text-inverse);
      color: var(--color-text-inverse);
      padding: var(--spacing-xs);
    }

    &__container {
      display: flex;
      justify-content: space-between;
    }

    &__up {
      align-items: center;
      display: flex;
      gap: var(--spacing-xs);
      margin-bottom: var(--spacing-xs);
    }

    &__travelata {
      height: 16px;
      width: 65px;
    }

    &__icon {
      fill: var(--color-text-inverse);
    }

    &__emirates {
      height: 20px;
      width: 77px;
    }

    &__typo {
      color: var(--color-text-inverse);
      max-width: 218px;
    }
  }
</style>
